import * as Yup from "yup";

// Define the validation schema using Yup
export const LoginSchema =  Yup.object().shape({
    email: Yup.string()
    .required('Email is required')
    .email('Invalid email format'),
    password: Yup.string()
    .required('Password is required')
    .min(2, 'Name must be at least 2 characters'),
});